import React from "react";
import { ISO639Lang } from "../../../../constans/languagesList";
import { DiscountPromocode } from "../../../../types/Promocodes";
import { getTranslation } from "../../../../utils/getTranslation";
import { flexPassTypeStrings } from "../../../FlexPass/flexPassUtils";
import s from "./InfoPromocode.module.css";

type Props = {
  promocode: DiscountPromocode;
};

export const InfoPromocode: React.FC<Props> = ({ promocode }) => {
  const {
    code,
    startDate,
    endDate,
    quantity,
    discount,
    type,
    subscriptions,
    selectionCombinations,
    onlyTalziExpense,
    usedBy,
    quantityPerUser,
    description,
  } = promocode;

  const discountValue = discount.amount
    ? `$${discount.amount / 100}`
    : discount.percentage
      ? `${discount.percentage}%`
      : "-";

  return (
    <div className={s.container}>
      {description && description.length > 0 && (
        <div className={s.section}>
          <span className={s.label}>Description:</span>
          <span className={s.value}>{description}</span>
        </div>
      )}
      <div className={s.row}>
        <span className={s.label}>Code:</span>
        <span className={s.value}>{code}</span>
      </div>

      <div className={s.row}>
        <span className={s.label}>Start / End:</span>
        <span className={s.value}>
          {new Date(startDate).toLocaleDateString()} /{" "}
          {new Date(endDate).toLocaleDateString()}
        </span>
      </div>

      <div className={s.row}>
        <span className={s.label}>Quantity:</span>
        <span className={s.value}>{quantity}</span>
      </div>
      <div className={s.row}>
        <span className={s.label}>Quantity per User:</span>
        <span className={s.value}>{quantityPerUser}</span>
      </div>
      <div className={s.row}>
        <span className={s.label}>Used:</span>
        <span className={s.value}>{usedBy.length}</span>
      </div>

      <div className={s.row}>
        <span className={s.label}>Discount:</span>
        <span className={s.value}>{discountValue}</span>
      </div>

      <div className={s.row}>
        <span className={s.label}>Type:</span>
        <span className={s.value}>{type}</span>
      </div>

      <div className={s.row}>
        <span className={s.label}>Only Talzi Expense:</span>
        <span className={s.value}>{onlyTalziExpense ? "Yes" : "No"}</span>
      </div>

      {subscriptions && subscriptions.length > 0 && (
        <div className={s.flexPassList}>
          <span className={s.label}>Subscriptions:</span>
          {subscriptions.map((pass) => (
            <div key={pass._id} className={s.listItem}>
              <div>{pass.title[0].text}</div>
              <div>
                {new Date(pass.startDate).toLocaleDateString()}
                {" - "}
                {new Date(pass.endDate).toLocaleDateString()}
              </div>
              <div>{ISO639Lang[pass.language]}</div>
              <div>{pass.mainSpecialization.specialization}</div>
              <div>{getTranslation(pass.level.title, "en")}</div>
              <div>{pass.cost / 100}$</div>
              <div>{flexPassTypeStrings[pass.type]}</div>
            </div>
          ))}{" "}
        </div>
      )}

      {selectionCombinations && selectionCombinations.length > 0 && (
        <div className={s.block}>
          <span className={s.label}>Combinations:</span>
          <ul className={s.list}>
            {selectionCombinations.map((c, i) => (
              <li key={i}>
                {ISO639Lang[c.language]} / {c.mainSpecialization.specialization}{" "}
                / {getTranslation(c.level.title)} /{" "}
                {getTranslation(c.topic.labels)}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
